/** Shared labels/values for shipment priority, category, packaging (project + admin flows). */

/** Values are lowercase — API expects high | medium | low */
export const SHIPMENT_PRIORITY_OPTIONS = [
  { value: 'high', label: 'High' },
  { value: 'medium', label: 'Medium' },
  { value: 'low', label: 'Low' },
];

/** Values match API: project | one_time_sales */
export const SHIPMENT_CATEGORY_OPTIONS = [
  { value: 'project', label: 'Project' },
  { value: 'one_time_sales', label: 'One time sales' },
];

export const SHIPMENT_PACKAGING_OPTIONS = [
  { value: 'PALLET', label: 'Pallet' },
  { value: 'CRATE_BOX', label: 'Crate box' },
  { value: 'UNPACKED', label: 'Unpacked' },
];

/** Form select values (PALLET | CRATE_BOX | UNPACKED) → API `packagingType` strings */
export function packagingFormValueToApi(formValue) {
  if (formValue == null || formValue === '') return undefined;
  const u = String(formValue).toUpperCase().replace(/-/g, '_');
  const map = { PALLET: 'pallet', CRATE_BOX: 'crate_box', UNPACKED: 'unpacked' };
  return map[u];
}

/** API `packagingType` / legacy fields → form select value */
export function packagingApiToFormValue(raw) {
  if (raw == null || raw === '') return undefined;
  let k = String(raw).trim();
  k = k.replace(/([a-z])([A-Z])/g, '$1_$2');
  k = k.toLowerCase().replace(/-/g, '_').replace(/\s+/g, '_');
  const map = {
    pallet: 'PALLET',
    crate_box: 'CRATE_BOX',
    cratebox: 'CRATE_BOX',
    unpacked: 'UNPACKED',
  };
  const mapped = map[k];
  if (mapped) return mapped;
  const up = String(raw).toUpperCase().replace(/-/g, '_').replace(/\s+/g, '_');
  return SHIPMENT_PACKAGING_OPTIONS.some((o) => o.value === up) ? up : undefined;
}

/** Normalize API row (camelCase, snake_case, or lowercase enums) for form state. */
export function normalizeShipmentMetaFromRecord(record) {
  if (!record) {
    return { priority: 'medium', shipmentCategory: 'project', packagingSubcategory: undefined };
  }
  const rawP =
    record.priority ??
    record.Priority ??
    record.shipment_priority ??
    record.shipmentPriority;
  const rawC =
    record.shipmentCategory ??
    record.shipment_category ??
    record.category ??
    record.Category;
  const rawPk =
    record.packagingType ??
    record.packaging_type ??
    record.packagingSubcategory ??
    record.packaging_subcategory ??
    record.subcategory ??
    record.Subcategory;

  let priority = 'medium';
  if (rawP) {
    const p = String(rawP).toLowerCase();
    if (p === 'high' || p === 'medium' || p === 'low') priority = p;
  }

  let shipmentCategory = 'project';
  if (rawC) {
    let c = String(rawC).trim();
    c = c.replace(/([a-z])([A-Z])/g, '$1_$2');
    c = c.toLowerCase().replace(/-/g, '_').replace(/\s+/g, '_');
    if (c === 'project') shipmentCategory = 'project';
    else if (
      c === 'one_time_sales' ||
      c === 'onetime_sales' ||
      c === 'one_time_sale' ||
      c === 'onetimesales'
    )
      shipmentCategory = 'one_time_sales';
  }

  const packagingSubcategory = rawPk ? packagingApiToFormValue(rawPk) : undefined;

  return { priority, shipmentCategory, packagingSubcategory };
}

/** Renders Select/AutoComplete menus on body so they are not clipped inside modals. */
export const getPopupContainerBody = () => document.body;
